module.exports = __webpack_public_path__ + "img/V-L-2-load-standup-base.88d2551b.png";